import type { ReactElement, ReactNode } from 'react';
import styles from './page-title.module.scss';

export interface PageTitleProps {
  children: ReactNode;
  className?: string;
}

export function PageTitle({ children, className }: PageTitleProps): ReactElement {
  return <h1 className={[styles.pageTitle, className].filter(Boolean).join(' ')}>{children}</h1>;
}
